import React, { useEffect } from 'react';
import { FiCheckCircle, FiAlertCircle, FiInfo } from 'react-icons/fi';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppStore';
import { removeToast, selectToasts, Toast as ToastType } from '../../store/slices/adminUiSlice';

const toastConfig = {
  success: { className: 'bg-green-700', Icon: FiCheckCircle },
  error: { className: 'bg-red-700', Icon: FiAlertCircle },
  info: { className: 'bg-charcoal border border-white/20', Icon: FiInfo },
};

const ToastItem: React.FC<{ toast: ToastType }> = ({ toast }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const t = setTimeout(() => dispatch(removeToast(toast.id)), 4000);
    return () => clearTimeout(t);
  }, [dispatch, toast.id]);
  const { className, Icon } = toastConfig[toast.type];
  return (
    <div
      role={toast.type === 'error' ? 'alert' : 'status'}
      className={`flex items-center gap-3 px-4 py-3 rounded-xl text-white text-sm shadow-lg ${className}`}
    >
      <Icon className="w-4 h-4 shrink-0" aria-hidden="true" />
      <span className="flex-1">{toast.message}</span>
      <button
        onClick={() => dispatch(removeToast(toast.id))}
        aria-label="Dismiss notification"
        className="w-6 h-6 -mr-1 flex items-center justify-center rounded-md text-white/60 hover:text-white hover:bg-white/10 transition-colors"
      >
        ✕
      </button>
    </div>
  );
};

export const ToastContainer: React.FC = () => {
  const toasts = useAppSelector(selectToasts);
  return (
    <div aria-live="polite" className="fixed top-4 right-4 z-50 flex flex-col gap-2 w-80">
      {toasts.map((t) => <ToastItem key={t.id} toast={t} />)}
    </div>
  );
};
